var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SoundQuestion',{attrs:{"role":_vm.role,"ask-question":"Luister goed naar het Sinterklaas!","question":"Hoe heet de hond van Sinterklaas?","correct-answer":"Pieter","wrong-answers":['Gierter',
  'Amerigo',
  'Benard van het hooglaagste Duinen',
  'Zwartje'
  ,'Dommie'],"ask-question-audio":require('@/assets/audio/vraag_6_vraag.mp3'),"answer-audio":require('@/assets/audio/vraag_6_antwoord.mp3'),"show-answer-after":3500}})}
var staticRenderFns = []

export { render, staticRenderFns }